<template>
  <div class="contentOut">
    <div class="notice-box1" v-if="isShowNotify && noticeInfo && noticeInfo.length > 0">
      <div class="left-text line_right">公告</div>
      <div class="swiper-box" @click="goNotifyPage">
        <annoswiper :dataList="noticeInfo"></annoswiper>
      </div>
    </div>
    <div class="prov-total">
      <div class="prov-total-sel">
        <div class="select" @click="handleQuarterShow()">
          <span>{{ quarterName }}</span>
          <div class="select-icon"></div>
        </div>
        <titleTab :tabList="titleTab" @titletabChange="titletabChange" v-if="shouldShowRegonFilter"></titleTab>
      </div>
      <div class="content">
        <div class="content-pd16">
          <tab v-if="dataTab && dataTab.length > 0" class="mt0" ref="drawer" :tabList="dataTab" :name="'dataTab'"
            @onSwitch="tabSwitch" :indexKey="'1'"></tab>
          <rankCharts v-if="ranking.length > 0" class="mt5" :rankList="ranking" @navToDetail="navToDetail"
            :checked="checked" />
          <template v-else>
            <!-- 没有数据提示 -->
            <div class="noData-bg">
              <nodata :noData="noData"></nodata>
            </div>
          </template>
        </div>
        <div :class="accountability || warning.length > 0 ? 'msg-div' : ''">
          <messageBottom :msgType="'error'" :content="accountability" v-if="accountability.length"></messageBottom>
          <div v-for=" (item, index) in warning" :key="index">
            <messageBottom :msgType="'warning'" v-if="warning.length" :content="item"></messageBottom>
          </div>
        </div>
      </div>

      <common-picker ref="commonPickerQuarter" :typeList="newQuarterList" :cols="cols1"
        @getTypeValue="getQuarterValue"></common-picker>
    </div>
  </div>
</template>
<script>
import nodata from "./../components/nodata"; // 没有数据
import annoswiper from "./../components/anno-swiper";
import api from "../../../service/modules/appraise";
import rankCharts from "./components/RankCharts";
import messageBottom from "./components/messageBottom";
import tab from "./../../../components/tab";
import titleTab from "./components/titleTab";

import commonPicker from "../../../components/base/commonPicker";
import API from "../../../service/index";
import commonAPI from "../../../utils/common";
import user from "../../../store/modules/user";

export default {
  components: {
    annoswiper,
    nodata,
    tab,
    rankCharts,
    titleTab,
    messageBottom,
    commonPicker,
  },
  data() {
    return {
      isShowNotify: false, // 是否展示公告
      noticeInfo: [], // 公告数据列表
      noData: {
        // 缺省组件展示信息
        title: "暂无数据",
      },
      quarterName: "", // 当前选择的年份
      yearQuarter: "",
      year: "",
      quarter: "2",
      computedQuarter: "", //季度值, 1,2,3,4
      accountability_bool: false,
      accountability: '',
      warning_bool: false,
      warning: [],
      ranking: [],
      dataTab: [],
      checked: true,
      titleTab: ["一类地区", "二类地区"],
      titleTabindex: 0,
      temAuthority: null,
      newQuarterList: [],
      temSaveAllYear: [],
      cols1: 1,
      defaultMenuList: [
        { value: "MENU1202", title: "投诉数据管理", callback: "3" },
        { value: "", title: "批量审核", callback: "4" },
      ],
      shouldShowRegonFilter: false,//是否显示地区切换
      areaLevel: '', // 用户信息中的 //1 省级， 2 州市级
      areaCode: '' //州市code
    };
  },
  watch: {
    quarterName: function () {
      this.shouldShowRegonFilter = ["2019年", "2020年", "2021年", "2022年"].includes(this.quarterName)
    }
  },
  created() {
    // const userinfo = commonAPI.getJsonLocal("appraiseNewLocalauthority");
    // // console.log('----userifo', userinfo);
    // if (
    //   userinfo.roleInfo &&
    //   (userinfo.userRole === "audit" || userinfo.userRole === "manager")
    // ) {
    //   this.isShowNotify = false;
    //   this.rightSetting();
    // } else if (userinfo.roleInfo && userinfo.userRole === "complaint") {
    //   this.isShowNotify = false;
    //   this.rightSetting_s();
    // } else if (
    //   userinfo.roleInfo &&
    //   (userinfo.userRole === "experSatisf" ||
    //     userinfo.userRole === "touristCounter")
    // ) {
    //   this.isShowNotify = false;
    // } else {
    //   this.isShowNotify = true;
    // }
    // // this.getnotify();
    this.initData();
  },
  activated() {
    console.log('111-----------------activated')
    const userinfo = commonAPI.getJsonLocal("appraiseNewLocalauthority");
    console.log('----userifo', userinfo);
    // if (
    //   userinfo.roleInfo &&
    //   (userinfo.userRole === "audit" || userinfo.userRole === "manager")
    // ) {
    //   this.isShowNotify = false;
    //   this.rightSetting();
    // } else if (userinfo.roleInfo && userinfo.userRole === "complaint") {
    //   this.isShowNotify = false;
    //   this.rightSetting_s();
    // } else if (
    //   userinfo.roleInfo &&
    //   (userinfo.userRole === "experSatisf" ||
    //     userinfo.userRole === "touristCounter")
    // ) {
    //   this.isShowNotify = false;
    // } else {
    //   this.isShowNotify = true;
    // }
    // this.getnotify();

  },
  deactivated() {
    console.log('111-----------------deactivated')
  },
  methods: {
    // 初始化页面
    async initData() {
      if (this.isShowNotify) {
        this.getnotify();
      }
      await Promise.all([this.getuserinfo(),this.getQuarters()])
      this.year = this.quarterName.substring(0, 4)
      //默认
      // this.getScoreList(
      //   Number(this.year),
      //   this.computedQuarter,
      //   1
      // );
    },
    rightSetting_s() {
      const _this = this;
      window.yyn.invokeJSB(
        "setActionBar",
        {
          icon: "setting",
          title: "",
          menuList: [{ title: "批量审核", callback: "4" }],
        },
        function (ret) {
          console.log("--1----回调按钮:", ret);
          if (ret === "4") {
            // this.$router.push({ path: "/appraise/batchReview" });
            _this.openWindow('批量审核', "/appraise/batchReview");
            // _this.goroute("/appraise/batchReview");
          }
        }
      );
    },
    rightSetting() {
      const _this = this;
      window.yyn.invokeJSB(
        "setActionBar",
        {
          icon: "setting",
          title: "",
          menuList: [
            { title: "通知公告设置", callback: "1" },
            { title: "任务管理", callback: "2" },
            { title: "投诉数据管理", callback: "3" },
            { title: "批量审核", callback: "4" },
          ],
        },
        function (ret) {
          console.log("--2----回调按钮:", ret);
          if (ret === "1") {
            // _this.goroute("/appraise/noticeManage");
            // this.$router.push({ path: "/appraise/noticeManage" });
            _this.openWindow("通知公告设置", "/appraise/noticeManage");
          } else if (ret === "2") {
            // this.$router.push({ path: "/appraise/taskManage" });
            // _this.goroute("/appraise/taskManage");
            _this.openWindow("任务管理", "/appraise/taskManage");
          } else if (ret === "3") {
            // this.$$router.push({ path: "/appraise/complaintManage" });
            // _this.goroute("/appraise/complaintManage");
            _this.openWindow("投诉数据管理", "/appraise/complaintManage");
          } else if (ret === "4") {
            // _this.$router.push({ path: "/appraise/batchReview" });
            // _this.goroute("/appraise/batchReview");
            _this.openWindow("批量审核", "/appraise/batchReview");
          }
        }
      );
    },
    goroute(path) {
      // this.$router.push(path);
    },
    openWindow(title, path) {
      window.yyn.invokeJSB(
        "openWindow",
        {
          openUrl: this.globalApp.getSystemInfo().host + "web/#" + path,
          isFullScreen: 0,
          setTitle: title,
          needLoading: 1,
        },
        (cb) => {
          console.log(cb, "callback");
        }
      );
    },
    // // 获取用户数据

    // 获取通知公告
    getnotify() {
      API.getNotify({}).then((res) => {
        console.log("-----顶部通知公告:", res);
        if (res.ret == 0) {
          this.noticeInfo = res.data;
        }
      });
    },
    // 获取季度年份
    getQuarters() {
      return new Promise((resolve, reject) => {
        API.getQuarters({}).then((res) => {
          let temyearList = [];
          for (let i = 0; i < res.data.length; i++) {
            for (let key in res.data[i]) {
              let value = res.data[i][key];
              let year = value.substring(0, 5);
              let quarter = value.substring(5, value.length);
              let obj = {};
              obj["text"] = year;
              obj["quarter"] = quarter;
              obj["quarterindex"] = key.substring(5);
              this.temSaveAllYear.push(obj);
              temyearList.push(year);
            }
          }
          // console.log("-----年季度:", temyearList);
          if (temyearList && temyearList.length > 0) {
            temyearList = Array.from(new Set(temyearList)).reverse();
            let temarr = [];
            for (let i = 0; i < temyearList.length; i++) {
              let obj = { text: temyearList[i] };
              temarr.push(obj);
            }
            // todo: 如果涉及跨年的话，要在这里改逻辑
            this.quarterName = temarr[0].text;
            this.choiceYear(temarr[0].text);
            this.newQuarterList = [temarr];
            resolve();
          }
          reject();
        });
      });
    },
    // 获取
    getScoreList(year, quarter, areaType) {
      let params = {
        year: year,
        quarter: quarter,
        // areaType:areaType
        assessType: 'all'
      }
      API.findUnitMonitorAssessData(params).then((res) => {
        if (res.ret == 0) {
          let tempResult = []
          if (res.data.showAll === 1) {
            tempResult = res.data.all ?? []
          } else if (res.data.showAll === 0 && this.shouldShowRegonFilter) {
            if (this.titleTabindex === 0) {
              tempResult = res.data.oneIconList ?? []
            } else {
              tempResult = res.data.twoIconList ?? []
            }
          } else {
            // 接口 2018 showAll 是 0 ，理论上应该是 1
            tempResult = res.data.all ?? []
          }
          if (tempResult.length) {
            this.ranking = tempResult.map((e, index) => ({
              area: e.area,
              areaName: e.areaName,
              ranking: e.rank,
              score: (e.score / 100).toFixed(2),
            }));
          } else {
            this.ranking = [];
          }

          if (res.data.warning) {
            this.warning_bool = true;
            this.warning = res.data.warning;
          } else {
            this.warning_bool = false;
            this.warning = [];
          }
          if (res.data.accountability) {
            this.accountability_bool = true;
            this.accountability = res.data.accountability;
          } else {
            this.accountability_bool = false;
            this.accountability = "";
          }
        }
      });
    },
    choiceYear(text) {
      console.log('output->[ choiceYear ] >', text)
      this.dataTab.length = 0;
      let temarr = [];
      if (this.temSaveAllYear && this.temSaveAllYear.length > 0) {
        for (let i = 0; i < this.temSaveAllYear.length; i++) {
          if (this.temSaveAllYear[i].text === text) {
            temarr.push(this.temSaveAllYear[i].quarter); //确定有多少个季度
          }
        }
      }
      // console.log('tab数据:', temarr);
      // TODO 外面改了年份，这里确定季度, 目前简单是是选择前一个季度
      this.dataTab.push.apply(this.dataTab, temarr.reverse());
      let index = this.dataTab[0]
      if (this.dataTab.length >= 2) {
        index = 1
      }
      this.computedQuarter = commonAPI.fixquarter(index);
    },
    // 跳转通知公告页面
    goNotifyPage() {
      this.$router.push({ path: "/appraise/announcement" });
    },
    // 获取年份
    getQuarterValue(value) {
      console.log('output->[ getQuarterValue ] >', value)
      
      // 选择年份 value=2023年
      this.quarterName = value[0].text;
      this.year = commonAPI.fixYear(this.quarterName)
      this.choiceYear(value[0].text);
      this.getScoreList(
        Number(this.year),
        Number(this.computedQuarter),
        this.titleTabindex + 1
      );
    },
    // 季度选择
    tabSwitch(index) {
      if (this.dataTab[index]) {
        this.computedQuarter = commonAPI.fixquarter(this.dataTab[index]);
        this.getScoreList(
          Number(commonAPI.fixYear(this.quarterName)),
          Number(this.computedQuarter),
          this.titleTabindex + 1
        );
      }
    },
    // 地区选择
    titletabChange(index) {
      this.titleTabindex = index;
      this.getScoreList(
        Number(commonAPI.fixYear(this.quarterName)),
        Number(this.computedQuarter),
        index + 1
      );
    },
    // 跳转详情页面
    navToDetail(val) {
      // console.log('----点击', val);
      console.log('output->[ navToDetail ] >', val)
      const params = commonAPI.getJsonLocal("onlyonlyreadone");
      if (params) {
        commonAPI.removeJsonLocal("onlyonlyreadone");
      }

      if(this.areaLevel == 2 && this.areaCode != val.area){
        this.$Toast("您没有该州市考核详情查看权限")
        return
      }
      
      this.$router.push({
        path: "/appraise/detail",
        query: {
          year: this.year,
          quarter: this.computedQuarter,
          area: val.area,
          areaName: val.areaName,
          isProvPriv: 1,
          compickFlag: false,
          compickFlag2: false,
          quarterName: this.quarterName + this.fixQuater(this.computedQuarter),
          isShowTopnofify: this.isShowNotify,
          uuuuxd: 0, //不需要解码，传递 0，需要解码传 1
          showAreaPicker:   this.areaLevel == 1,// 是否筛选城市
          showQuarterPicker:  this.areaLevel == 1,//年份季度
        },
      });

    },
    fixQuater(index) {
      if (index == 1) {
        return "第一季度";
      } else if (index == 2) {
        return "第二季度";
      } else if (index == 3) {
        return "第三季度";
      } else if (index == 4) {
        return "第四季度";
      }
    },
    // 唤起季度选择组件
    handleQuarterShow() {
      this.$refs.commonPickerQuarter.showPicker();
    },
    getuserinfo() {
      return new Promise((resolve, reject) => {
        API.getUserInfo({}).then(res => {
          if (res.ret == 0) {
            const hostoryAuth = commonAPI.getJsonLocal(
              "appraiseNewLocalauthority"
            );
            if (hostoryAuth) {
              commonAPI.removeJsonLocal("appraiseNewLocalauthority");
            }
            commonAPI.setJsonLocal("appraiseNewLocalauthority", res.data);
            if (res.data) {

              this.areaLevel = res.data.areaLevel;
              this.areaCode = res.data.area
              console.log("权限值:", res.data);
            }
            resolve()
          }else{
            reject()
          }
        }).catch(err=>{
          reject()
          console.log('output->[ getUserInfo ] >', err)
        });
      });

    },
  },
};
</script>
<style lang="less" scoped>
.contentOut {
  width: 100%;
  padding: 0 12px;
}

.noData-bg {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 100px;
}

.notice-box1 {
  position: relative;
  display: flex;
  align-items: center;
  height: 30px;
  margin-top: 16px;
  background: rgba(245, 245, 245, 1);
  border-radius: 3px;
  box-sizing: border-box;
  padding-left: 16px;
  margin-bottom: 19px;

  .left-text {
    font-size: 12px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: bold;
    color: rgba(51, 51, 51, 1);
    line-height: 30px;
    padding-right: 16px;
    width: 40px;
    margin-right: 16px;
    height: 30px;
    margin-top: 2px;
  }

  .swiper-box {
    width: calc(100% - 40px);
    height: 30px;
  }
}

.prov-total {
  margin-top: 24px;

  &-sel {
    display: flex;
    justify-content: space-between;

    .select {
      display: flex;
      align-items: center;

      span {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: bold;
        color: rgba(51, 51, 51, 1);
        padding-right: 4px;
      }

      .select-icon {
        width: 6px;
        height: 4px;
        background: url("../../../assets/image/xiala.png") no-repeat;
        background-size: 6px 4px;
      }
    }

    .search {
      width: 15px;
      height: 15px;
      background: url("../../../assets/image/sousuo.png") no-repeat;
      background-size: 15px 15px;
    }
  }

  .content {
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 15px 0px rgba(0, 0, 0, 0.06);
    border-radius: 3px;
    margin-top: 12px;

    // padding-bottom: 4px;
    &-item {
      display: flex;

      .total {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 24px 0;

        .title {
          display: flex;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(51, 51, 51, 1);
          line-height: 12px;

          .icon {
            width: 12px;
            height: 12px;
            margin-left: 4px;
          }
        }

        .num {
          font-size: 32px;
          font-family: DIN-Bold, DIN;
          font-weight: bold;
          color: rgba(54, 179, 116, 1);
          line-height: 32px;
          margin-top: 9px;
        }

        .compare {
          display: flex;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(153, 153, 153, 1);
          line-height: 17px;
          margin-top: 8px;

          div:last-child {
            margin-left: 4px;
          }

          .bule {
            color: #2283e6;
          }

          .red {
            color: #ff4d4d;
          }

          .green {
            color: #36b374;
          }
        }
      }

      .total:nth-child(2) {
        border-left: solid 1px #eeeeee;
      }
    }

    &-item:first-child {
      border-bottom: solid 1px #ededed;
    }

    &-item:last-child {
      border-bottom: solid 1px #ededed;
    }

    &-pd16 {
      //   padding: 16px 16px 12px 16px;
      overflow: hidden;

      .mt0 {
        // margin-top: 0;
        margin: 16px 16px 0 16px;
      }

      .mt13 {
        // margin-top: 13px;
        margin: 13px 16px 12px 16px;
      }
    }

    .msg-div {
      //   margin: 15px 16px 0 16px;
      width: 100%;
      padding: 15px 16px 4px 16px;
    }

    .msg-div:last-child {
      margin-bottom: 0;
    }
  }
}

.address-tab /deep/ .address-tab-div1 {
  border-radius: 0;
}

.address-tab /deep/ .address-tab-div2 {
  border-radius: 0;
}

.mt5 {
  margin-top: 5px;
}
</style>
